import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import ListaResumo from "./ListaResumo";

const FormRoteiroResumo = ({ sequencialRoteiro }) => {
  const [arvore, setArvore] = useState([]);

  const { request: requestConsultaResumo, data: dataConsultaResumo } = useApiClient();

  useEffect(() => {
    if (dataConsultaResumo) {
      setArvore(dataConsultaResumo.result.galhos);
    }
  }, [dataConsultaResumo]);

  useEffect(() => {
    requestConsultaResumo(apiRoutes.fiscalizacao.parametrizacao.consultaResumoRoteiro, { sequencialRoteiro });
  }, [requestConsultaResumo, sequencialRoteiro]);

  return (
    <>
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <h6 className="m-0 font-weight-bold text-primary flex-grow-1 titulo-resumo-roteiro">Resumo</h6>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} sm={12} md={1}>
          {arvore &&
            arvore?.map((x) => (
              <Row>
                <ListaResumo item={x} />
              </Row>
            ))}
        </Form.Group>
      </Row>
    </>
  );
};

export default FormRoteiroResumo;
